<template>
  <div class="containerSearchDirection">
   

   

    <el-row :gutter="20" class="rowComponentOfDirection rowNumberDirection">
      <el-col :span="24">
        <div class="inner-addon right-addon">
          <i
            class="uil uil-search glyphicon iconInput"
            v-show="isEmptyNumber"
          ></i>
          <i
            class="uil uil-times glyphicon iconInput"
            style="cursor: pointer"
            v-show="isDirtyNumber"
            @click="cleanInputNumber"
          ></i>
          <vs-input
            type="text"
            class="inputNumberDirection"
            placeholder="Coordenada Y, Coordenada X"
            ref="refInputNumberVia"
            v-model="numberDirection"
            @keydown.enter="pressEnterNumVia"

            @cleanDistrictEmittion="cleanComponentsOfDirectionByDistrito"
          />
        </div>
      </el-col>
    </el-row>

    

 

    <el-row :gutter="20" class="rowComponentOfDirection rowbtnSearchDirection">
      <el-col :span="24">
        <el-button
          class="btnSearchDirection"
          type="success"
          @click="searchDirection"
          >Buscar</el-button
        >
      </el-col>
    </el-row>

    <!-- componenete de busqueda -->
    <el-row :gutter="20" v-if="userIsBasic">
      <el-col :span="24">
        <div style="padding-top: 20px; text-align: center">Sectores:</div>
      </el-col>
    </el-row>

    <el-card class="box-card-claro">
      <div slot="header" class="clearfix">
        <img
          style="height: 120px; border-radius: 5px"
          src="@/assets/images/logo bravo maps_291020.jpg"
          class="image"
        />
      </div>
      <div class="text item" v-if="userIsBasic">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-coordinates-geofencing">
            <span style="color: #8b4513">Coordenadas: </span>
          </el-col>
          <el-col :span="20" :offset="2" class="col-coordinates-geofencing">
            {{ latitud_general }},
            {{ longitud_general }}
          </el-col>
          <el-col :span="20" :offset="2" class="col-button-geofencing">
            <el-button
              class="button-geofencing"
              @click="getGeofencingInalambricoIfiNacional()"
              type="primary"
              >IFI Nacional</el-button
            >
          </el-col>
          <el-col :span="20" :offset="2" class="col-button-geofencing">
            <el-button
              class="button-geofencing"
              @click="getGeofencingInalambricoLteNacional()"
              type="success"
              >LTE Nacional</el-button
            >
          </el-col>
          <el-col :span="20" :offset="2" class="col-button-geofencing">
            <el-button
              class="button-geofencing"
              @click="getGeofencingEntregaClientes()"
              type="danger"
              >Entrega clientes</el-button
            >
          </el-col>
          <el-col :span="20" :offset="2" class="col-button-geofencing">
            <el-button
              class="button-geofencing"
              @click="getGeofencingCoberturaHorizontal()"
              type="warning"
              >HFC-FTTH</el-button
            >
          </el-col>
        </el-row>

        <!-- <el-row :gutter="20">
          <el-col :span="10">Nombre: </el-col>
          <el-col :span="11" id="foo">
            <el-input
              class="delivery_code"
              ref="inputCode"
              v-model="delivery.name"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <el-tooltip
              class="item"
              effect="dark"
              content="Copiar"
              placement="top"
            >
              <i
                @click="copyText"
                style="cursor: pointer"
                class="el-icon-document-copy"
              ></i>
            </el-tooltip>
          </el-col>
        </el-row> -->
      </div>
    </el-card>

    <el-dialog
      title="INALAMBRICO: IFI"
      :visible.sync="dialog_ifi_nacional"
      width="40%"
      center
    >
      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">IFI NACIONAL</el-tag>
          </el-col>
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Estado: </span>
            <span class="valueClaroGeofencing">{{
              inalambrico_ifinacional.sectorStatus
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Plano: </span>
            <span class="valueClaroGeofencing">{{
              inalambrico_ifinacional.plano
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Coordenada Domicilio: </span
            ><span class="valueClaroGeofencing"
              >{{ inalambrico_ifinacional.lat }},{{
                inalambrico_ifinacional.long
              }}</span
            ></el-col
          >
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">IFI 5G NACIONAL</el-tag>
          </el-col>
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Estado: </span>
            <span class="valueClaroGeofencing">{{
              inalambrico_ifinacional5g.sectorStatus
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Plano: </span>
            <span class="valueClaroGeofencing">{{
              inalambrico_ifinacional5g.plano
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Coordenada Domicilio: </span
            ><span class="valueClaroGeofencing"
              >{{ inalambrico_ifinacional5g.lat }},{{
                inalambrico_ifinacional5g.long
              }}</span
            ></el-col
          >
        </el-row>
      </div>
    </el-dialog>

    <el-dialog
      title="INALAMBRICO: LTE "
      :visible.sync="dialog_lte_nacional"
      width="40%"
      center
    >
      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">LTE NACIONAL</el-tag>
          </el-col>
        </el-row>
      </div>
      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Estado: </span>
            <span class="valueClaroGeofencing">{{
              inalambrico_ltenacional.areaStatus
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Plano: </span
            ><span class="valueClaroGeofencing">{{
              inalambrico_ltenacional.areaName
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Coordenada Domicilio: </span
            ><span class="valueClaroGeofencing"
              >{{ inalambrico_ltenacional.lat }},{{
                inalambrico_ltenacional.long
              }}</span
            ></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Antena: </span>
            <span class="valueClaroGeofencing">{{
              inalambrico_ltenacional.antena
            }}</span></el-col
          >
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">LTE SINR NACIONAL</el-tag>
          </el-col>
        </el-row>
      </div>
      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing"
              >(Información válida sólo para Técnicos Claro)
            </span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">SINR: </span
            ><span class="valueClaroGeofencing">{{
              inalambrico_lte_sinr_nacional.sinr
            }}</span></el-col
          >
        </el-row>
      </div>
    </el-dialog>

    <!-- DIALOG PARA ENTREGA A CLIENTES -->
    <el-dialog
      title="ENTREGA A CLIENTES"
      :visible.sync="dialog_entrega_clientes"
      width="40%"
      center
    >
      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Estado: </span>
            <span
              :style="{ color: entrega_clientes.color }"
              class="valueClaroGeofencing"
              >{{ entrega_clientes.areaStatus }}</span
            ></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Plano: </span
            ><span
              :style="{ color: entrega_clientes.color }"
              class="valueClaroGeofencing"
              >{{ entrega_clientes.areaName }}</span
            ></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Condicion: </span
            ><span
              :style="{ color: entrega_clientes.color }"
              class="valueClaroGeofencing"
              >{{ entrega_clientes.areaCondicion }}</span
            ></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Coordenada Domicilio: </span
            ><span
              :style="{ color: entrega_clientes.color }"
              class="valueClaroGeofencing"
              >{{ entrega_clientes.lat }},{{ entrega_clientes.long }}</span
            ></el-col
          >
        </el-row>

        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Distrito: </span
            ><span
              :style="{ color: entrega_clientes.color }"
              class="valueClaroGeofencing"
              >{{ entrega_clientes.district }}</span
            ></el-col
          >
        </el-row>
      </div>
    </el-dialog>

    <!-- DIALOG PARA COBERTURA HORIZONTAL -->
    <el-dialog
      title=" HFC-FTTH"
      :visible.sync="dialog_cobertura_horizontal"
      width="40%"
      center
    >
      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">DATOS GENERALES</el-tag>
          </el-col>
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Plano: </span
            ><span class="valueClaroGeofencing">{{
              cobertura_horizontal.areaName
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Tecnologia: </span
            ><span class="valueClaroGeofencing">{{
              cobertura_horizontal.tecnology
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Distrito: </span
            ><span class="valueClaroGeofencing">{{
              cobertura_horizontal.district
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Departamento: </span
            ><span class="valueClaroGeofencing">{{
              cobertura_horizontal.department
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Region: </span
            ><span class="valueClaroGeofencing">{{
              cobertura_horizontal.region
            }}</span></el-col
          >
        </el-row>

        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Coordenada Domicilio: </span
            ><span class="valueClaroGeofencing"
              >{{ cobertura_horizontal.lat }},{{
                cobertura_horizontal.long
              }}</span
            ></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Condición: </span
            ><span class="valueClaroGeofencing"
              >{{ cobertura_horizontal.condition_value }}</span
            ></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Tipo Olt: </span
            ><span class="valueClaroGeofencing"
              >{{ cobertura_horizontal.tipo_olt }}</span
            ></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Color: </span
            ><span class="valueClaroGeofencing"
              >{{ cobertura_horizontal.color }}</span
            ></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Actualización : </span
            ><span class="valueClaroGeofencing"
              >{{ cobertura_horizontal.update_value }}</span
            ></el-col
          >
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">SERVICIOS RESIDENCIALES</el-tag>
          </el-col>
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Estado: </span>
            <span class="valueClaroGeofencing">{{
              cobertura_horizontal.areaStatus
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Servicios: </span
            ><span class="valueClaroGeofencing">{{
              cobertura_horizontal.services
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Max. Capacidad: </span
            ><span class="valueClaroGeofencing">{{
              cobertura_horizontal.capacity
            }}</span></el-col
          >
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">SERVICIOS CORPORATIVOS</el-tag>
          </el-col>
        </el-row>
      </div>
      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Estado: </span>
            <span class="valueClaroGeofencing">{{
              cobertura_horizontal.corporate_status
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroGeofencing">Servicios: </span
            ><span class="valueClaroGeofencing">{{
              cobertura_horizontal.corporate_service
            }}</span></el-col
          >
        </el-row>
      </div>
    </el-dialog>

    <el-dialog
      title="Ingrese un número de DNI, RUC, SOT o Carnet de Extranjería"
      :visible.sync="centerDialogDni"
      width="30%"
      center
    >
      <select v-model="document" class="select-css" id="documents">
        <option
          v-for="item in documents"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></option>
      </select>

      <vs-input
        style="margin-top: 20px; width: 100%"
        type="number"
        v-model="dni"
        label="Documento:"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogDni = false">Cancel</el-button>
        <el-button type="primary" @click="searchDirection">Buscar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DistritoTypeAhead from "./DistritoTypeAhead";
import ViaTypeahead from "./ViaTypeAhead";
import NucleoUrbano from "./NucleoUrbanoTypeAhead";

import axios from "axios";

import { mapState, mapMutations } from "vuex";

export default {
  components: {
    DistritoTypeAhead,
    ViaTypeahead,
    NucleoUrbano,
  },

  data() {
    return {
      centerDialogDni: false,
      dni: "",
      // user:{},

      numberDirection: "",
      isFocusNumber: false,
      manzanaDirection: "",
      access_token: "",
      device: "Desktop",
      urlBase: "",
      nivel_search: "",
      classForPrecision: "",

      geocoderApi: null,
      resultados: [],

      srcImgCompany: "@/assets/images/pardos.jpg",

      delivery: {
        restaurant: "",
        proveedor: "",
        unidad: "",
        distancia: "0",
        codigo: "",
      },

      latitud_address: "",
      longitud_address: "",

      urlBuilderArea: "",
      urlDataEdificios :"",
      dataEdicios : [
      {
        "plano": "5518G04",
        "direccion": "AV. 28 DE JULIO 757 - 759",
        "tecnologia": "HFC",
        "distrito": "MIRAFLORES",
        "departamento": "LIMA",
        "region": "LIMA",
        "nombre": "CENTRO EMPRESARIA EL LIBERTADOR",
        "fecha_activacion": "21/05/2012",
        "edificio": "E29",
        "nro_pisos": "10",
        "nro_departamentos": "16",
        "oficinas": "OFICINAS",
        "servicios_residenciales": "03 Play (Internet + Telefonía + Video HD)+IPTV",
        "maxima_capacidad": "500 MB",
        "estado_residencial": "CON COBERTURA",
        "estado_corporativo": "CON COBERTURA",
        "servicios_corporativos": "RED CLARO NEGOCIO",
        "lat": "-12.128049",
        "lon": "-77.026348"
      }
    ],

      dialog_ifi_nacional: false,

      inalambrico_ifinacional: {
        tieneCobertura: false,
        sectorStatus: "",
        plano: "",
        lat: "",
        long: "",
      },

      inalambrico_ifinacional5g: {
        tieneCobertura: false,
        sectorStatus: "",
        plano: "",
        lat: "",
        long: "",
      },

      dialog_lte_nacional: false,
      inalambrico_ltenacional: {
        tieneCobertura: false,
        areaStatus: "",
        areaName: "",
        lat: "",
        long: "",
        antena: "",
      },

      inalambrico_lte_sinr_nacional: {
        tieneCobertura: false,
        sinr: "",
      },

      dialog_entrega_clientes: false,
      entrega_clientes: {
        tieneCobertura: false,
        areaStatus: "",
        areaCondicion: "",
        areaName: "",
        color: "red",
        lat: "",
        long: "",
        district: "",
      },

      dialog_cobertura_horizontal: false,
      cobertura_horizontal: {
        tieneCobertura: false,
        areaStatus: "",
        areaName: "",
        tecnology: "",
        district: "",
        department: "",
        region: "",
        services: "",
        capacity: "",
        corporate_status: "",
        corporate_service: "",
        lat: "",
        long: "",
      },

      userIsBasic: false,
      userIsIntern: false,
      document: "DNI",
      documents: [
        { label: "DNI", value: "DNI" },
        { label: "RUC", value: "RUC" },
        { label: "SOT", value: "SOT" },
        { label: "Carnet extranjeria", value: "carnet-extranjeria" },
      ],
    };
  },

  created() {
    this.urlBase = process.env.VUE_APP_GEOCODING;
    this.access_token = process.env.VUE_APP_TOKEN_APIS;
    this.urlBuilderArea = process.env.VUE_APP_BUILDER_API_AREA_HOST;
    this.urlDataEdificios = process.env.VUE_APP_API_EDIFICIOS;
  },
  watch: {
    user(newValue, oldValue) {
      console.log("WATCH USER");
      console.log(newValue);
      this.userIsBasic = newValue.roles.includes("ROLE_USER");
      this.userIsIntern = newValue.roles.includes("ROLE_CONSULTANT");

      this.user = newValue;

      console.log(this.user);

      console.log(this.userIsAdmin);
    },
  },
  mounted() {
    let app = this;
    if (app.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      app.access_token = tokenData.data.access_token;

      console.log("usuario");
      console.log(this.user);

      app.user = this.$store.state.user;

      this.userIsBasic = this.user.roles.includes("ROLE_USER");
      this.userIsIntern = newValue.roles.includes("ROLE_CONSULTANT");

    }


    //Seleccionar el primer elemento
    console.log("SE MONTO EL COMPONENET DIRECCION");
    // this.$refs["inputDistrito"].$el.focus();
    // this.$refs["refInputNumberVia"].$el.querySelector("input").value = "";
  },
  computed: {
    ...mapState(["map", "latitud_general", "longitud_general", "user"]),
    isEmptyNumber() {
      return this.numberDirection === "";
    },

    isDirtyNumber() {
      return !!this.numberDirection;
    },

    isEmptyManzana() {
      return this.manzanaDirection === "";
    },

    isDirtyManzana() {
      return !!this.manzanaDirection;
    },
  },

  methods: {
    copyText() {
      var vm = this;
      /* Get the text field */
      var copyText = vm.$refs.inputCode;
      /* Select the text field */
      copyText.select();
      /* Copy the text inside the text field */
      document.execCommand("copy");
      /* Alert the copied text */
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }
    },
    cleanInputNumber() {
      this.numberDirection = "";
      // this.$refs["refInputNumberVia"].$el.querySelector("input").focus();
    },

    cleanInputManzana() {
      this.manzanaDirection = "";
      // this.$refs["refInputManzana"].$el.querySelector("input").focus();
    },

    distritoSelected(e) {
      console.log("sE SELECCCIONO EL DISTRITO");
      // this.$refs["inputVia"].$el.querySelector("input").focus();
      //this.$el.querySelector('input').focus()
    },

    nucleoUrbanoSelected() {
      // this.$refs["refInputManzana"].$el.querySelector("input").focus();
    },

    cleanComponentsOfDirectionByDistrito() {
      this.$store.commit("store_setUbigeo", "");

      this.$refs["inputVia"].data = "";
      this.$store.commit("SET_TIPO_VIA_DIRECTION", 0);
      this.$store.commit("SET_VIA_DIRECTION", "");

      this.$refs["inputNucleoUrbano"].data = "";
      this.$store.commit("SET_TIPO_NU_DIRECTION", 0);
      this.$store.commit("SET_NU_DIRECTION", "");

      this.numberDirection = "";
      this.manzanaDirection = "";

      this.nivel_search = "";
    },

    cleanComponentsOfDirectionByVia() {
      this.$store.commit("SET_TIPO_VIA_DIRECTION", 0);
      this.$store.commit("SET_VIA_DIRECTION", "");

      this.$refs["inputNucleoUrbano"].data = "";
      this.$store.commit("SET_TIPO_NU_DIRECTION", 0);
      this.$store.commit("SET_NU_DIRECTION", "");

      this.numberDirection = "";
      this.manzanaDirection = "";

      this.nivel_search = "";
    },

    cleanComponentsOfDirectionByNucleoUrbano() {
      this.manzanaDirection = "";
    },

    checkLogin() {
      return this.$store.state.isLoggedIn;
    },

    selectVia() {
      this.isFocusNumber = true;
      // this.$refs["refInputNumberVia"].$el.querySelector("input").focus();
      // this.$refs["refInputNumberVia"].$el.querySelector("input").value = "";
      //document.getElementById("numberDirection").focus();
    },

    /*cleanInputNumber(){
      this.numberDirection = '';
      document.getElementById("numberDirection").focus();
    },*/

    pressEnterNumVia(e) {
      let codePressEnter = 13;
      if (e.keyCode === codePressEnter) {
        this.validateDni();
      }
    },

    pressEnterManzanaDirection(e) {
      let codePressEnter = 13;
      if (e.keyCode === codePressEnter) {
        this.validateDni();
      }
    },

    validateDni() {
      //this.searchDirection();

      //this.centerDialogDni = true;
    },

    searchDirection() {
      /* switch (this.document) {
        case "DNI":
          if (this.dni.length != 8) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de un DNI",
              type: "warning",
            });
            return;
          }

          if (this.dni == "00000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }

          break;
        case "RUC":
          if (this.dni.length != 11) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de un RUC",
              type: "warning",
            });
            return;
          }

          if (this.dni == "00000000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        case "SOT":
          if (this.dni.length != 8) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de SOT",
              type: "warning",
            });
            return;
          }
          if (this.dni == "00000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        case "carnet-extranjeria":
          if (this.dni.length != 12) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud del carnet de extranjeria",
              type: "warning",
            });
            return;
          }
          if (this.dni == "000000000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        default:
        // code block
      }  */

      //primero asiganr el token
      let layerMarker = this.$store.getters.layerMarkerSearcher;
      if (layerMarker) {
        //this.$store.commit("SET_LAYER_MARKER", marker)
        this.map.removeLayer(layerMarker);
      }

      let layerMarkerBuildings = this.$store.getters.layerMarkerBuildingsSearcher;
            if (layerMarkerBuildings) {
              console.log("Se eliminar LayerEdificios")
              console.log(layerMarkerBuildings)
              this.map.removeLayer(layerMarkerBuildings);
              
            }

      let ubigeoOfStore = this.$store.getters.ubigeo;
      let viaOfStore = this.$store.getters.via;
      let tipoViaOfStore = this.$store.getters.tipoVia;
      let nameNucleoUrbano = this.$store.getters.nucleoUrbano;
      let tipoNucleoUrbano = this.$store.getters.tipoNucleoUrbano;

      let address;
     

      let nameRoute = "";
      if (viaOfStore) {
        if (tipoViaOfStore) {
          nameRoute = tipoViaOfStore + " " + viaOfStore;
        } else {
          nameRoute = viaOfStore;
        }
      }

      

   

      let url =
        this.urlBase +
        "latlon=" +
        this.numberDirection +
        "&maps=true&mapsaccount=" +
         this.user.email;

      /*let url =
        this.urlBase +
        "address=" +
        address +
        "&segments=locality_id:" +
        ubigeoOfStore +
        "&key=" +
        this.access_token;*/
      // console.log(url)
      let self = this;
      if(this.numberDirection){

        axios
          .get(url)
          .then(function (response) {
            console.log("Se geocodifico correctamente");
            console.log(response);

            console.log("Data para edificios")
            if(response.data.status == 'OK'){

              self.recibiresultados(response.data);
              self.centerDialogDni = false;
              self.dni = "";
            }else{
              this.$notify({
              title: "Aviso",
              message: "No se encontraron resultados",
              type: "warning",
            });
            }

            //resolve(response.data);
          })
          .catch(function (error) {
            console.log(error);
            self.centerDialogDni = false;
            self.dni = "";
            //reject(error);
          });
      }else{
        this.$notify({
          title: "Aviso",
          message: "Ingrese las coordenadas porfavor",
          type: "warning",
        });
      }
      
    },

    apiGetDataEficios(lat, lng){
      let arrayDataEdificios = [];
      let url =  this.urlDataEdificios + "latlon=" + lat + ","
                + lng + "&distance=100"
       axios.get(url).then((resp) => {
         console.log(resp)
         if(resp.length > 0){
          for(var i = 0; i < resp.length ; i++){

            let htmlPopup = `<b>Plano:  ${this.dataEdicios[i].plano}</b>  </br>
            <b>Dirección:  ${this.dataEdicios[i].direccion}</b> </br>
            <b>Tecnología:  ${this.dataEdicios[i].tecnologia}</b> </br>
            <b>Distrito:  ${this.dataEdicios[i].distrito}</b> </br>
            <b>Departamento:  ${this.dataEdicios[i].departamento}</b> </br>
            <b>Región:  ${this.dataEdicios[i].region}</b> </br>
            <b>Nombre:  ${this.dataEdicios[i].nombre}</b> </br>
            <b>Fecha Activación:  ${this.dataEdicios[i].fecha_activacion}</b> </br>
            <b>Edificio:  ${this.dataEdicios[i].edificio}</b> </br>
            <b>N° Pisos:  ${this.dataEdicios[i].nro_pisos}</b> </br>
            <b>N° Departamento:  ${this.dataEdicios[i].nro_departamentos}</b> </br>
            <b>Oficinas:  ${this.dataEdicios[i].oficinas}</b> </br>
            <b>Servicios Residencial:  ${this.dataEdicios[i].servicios_residenciales != undefined ? this.dataEdicios[i].servicios_residenciales : ''}</b> </br>
            <b>Máxima Capacidad:  ${this.dataEdicios[i].maxima_capacidad != undefined ? this.dataEdicios[i].maxima_capacidad : ''}</b> </br>
            <b>Estado Residencial:  ${this.dataEdicios[i].estado_residencial != undefined ? this.dataEdicios[i].estado_residencial: ''}</b> </br>
            <b>Estado Coorporativo:  ${this.dataEdicios[i].estado_corporativo != undefined ? this.dataEdicios[i].estado_corporativo : ''}</b> </br>
            <b>Servicio Coorporativo:  ${this.dataEdicios[i].servicios_corporativos != undefined ? this.dataEdicios[i].servicios_corporativos : ''}</b> </br>
            `
            let datajson = {
              text: htmlPopup,
               lat: this.dataEdicios[i].lat,
               lon: this.dataEdicios[i].lon

            }

            arrayDataEdificios.push(datajson)
          }
         }
       })
      console.log(arrayDataEdificios)
      

       return arrayDataEdificios ;

    },

    recibiresultados: function (result) {
      console.log("analizar resultado");
      let self = this;
      if (result.status == "OK") {
        console.log("resultado ok");
        var customIcon = new L.Icon({
          iconUrl: require("../../assets/images/icon_marker.png"),
          iconAnchor: [12, 30],
        });


        var iconEdificiosAzul = new L.Icon({
          iconUrl: require("../../assets/images/buildings.png"),
          iconAnchor: [12, 30],
          iconSize: [ 28, 41 ],
          
        });
        var iconEdificiosRojo = new L.Icon({
          iconUrl: require("../../assets/images/building-red.png"),
          iconAnchor: [12, 30],
          iconSize: [ 28, 41 ],
          
        });
        var iconEdificiosVerde = new L.Icon({
          iconUrl: require("../../assets/images/building-green.png"),
          iconAnchor: [12, 30],
          iconSize: [ 28, 41 ],
          
        });

       



        let results = result.results;

        for (var item in results) {
          if (item == 0) {
            console.log("calcular delivery");

            let coordinates = results[item].geometry.coordinates;
            let latitud = coordinates.lat;
            let longitud = coordinates.lon;


             //validar data edificios
            console.log("Data para edificios")
            console.log(coordinates)

           
            
            

            self.$store.commit("SET_LATITUD_GENERAL", coordinates.lat);
            self.$store.commit("SET_LONGITUD_GENERAL", coordinates.lon);

            self.latitud_address = coordinates.lat;
            self.longitud_address = coordinates.lon;
            //let tokenObject = JSON.parse(localStorage.getItem("geodir_Token"));

            //let token = tokenObject.data.access_token;
            //let token = "7c54939f-6876-4f58-8c0c-a2b19c7906d6";

            /*axios
              .get(
                this.urlBuilderArea +
                  "latlon=" +
                  latitud +
                  "," +
                  longitud +
                  "&layer_area_id=xfgimiga2095&key=" +
                  token,
                {
                  headers: { Authorization: `Bearer ${token}` },
                }
              )
              .then((response) => {
                self.delivery = response.data;
              });*/

            var latlng = L.GeoJSON.coordsToLatLng([
              coordinates.lon,
              coordinates.lat,
            ]);

            this.evaluatePrecision(
              results[item].geometry.geocoding_type,
              results[item].result_types
            );

            this.map.setView(latlng, 18, {
              duration: 1,
            });
            var marker = L.marker(latlng, { icon: customIcon })
              .addTo(this.map)
              .bindPopup(results[item].standard_address)
              .openPopup();



           //marker edificos
           var markerLayerBuildgindGroup = L.layerGroup();
            let url =  this.urlDataEdificios + "latlon=" + latitud + ","
                      + longitud + "&distance=100"
                      axios.get(url).then((resp) => {
            console.log("DATA EDIFICIOS");
            console.log(resp);
            if (resp.data.length > 0) {
              let datFiltada = resp.data.filter((response) => response.plano != undefined)
              for (var i = 0; i < resp.data.length; i++) {
                const buildingData = resp.data[i];
                let htmlPopup = `<b>Plano: ${buildingData.plano || ''}</b></br>
                                <b>Dirección: ${buildingData.direccion}</b></br>
                                <b>Tecnología: ${buildingData.tecnologia}</b></br>
                                <b>Distrito: ${buildingData.distrito}</b></br>
                                <b>Departamento: ${buildingData.departamento || ''}</b></br>
                                <b>Región: ${buildingData.region}</b></br>
                                <b>Nombre: ${buildingData.nombre || ''}</b></br>
                                <b>Fecha Activación: ${buildingData.fecha_activacion}</b></br>
                                <b>Edificio: ${buildingData.edificio}</b></br>
                                <b>N° Pisos: ${buildingData.nro_pisos}</b></br>
                                <b>N° Departamento: ${buildingData.nro_departamentos}</b></br>
                                <b>Oficinas: ${buildingData.oficinas || ''}</b></br>
                                <b>Servicios Residencial: ${buildingData.servicios_residenciales}</b></br>
                                <b>Máxima Capacidad: ${buildingData.maxima_capacidad}</b></br>
                                <b>Estado Residencial: ${buildingData.estado_residencial}</b></br>
                                <b>Estado Coorporativo: ${buildingData.estado_corporativo}</b></br>
                                <b>Estado Coorporativo: ${buildingData.estado_corporativo}</b></br>
                                <b>Latitud: ${buildingData.lat}</b></br>
                                <b>Longitud: ${buildingData.lon}</b></br>`;

                let latlonEdificios = L.GeoJSON.coordsToLatLng([buildingData.lon, buildingData.lat]);
                var markerEdificios;
                if(buildingData.tecnologia === 'HFC'){
                 markerEdificios = L.marker(latlonEdificios, { icon: iconEdificiosRojo })
                  
                  .bindPopup(htmlPopup)
                  .openPopup();
                
               
                }else if(buildingData.tecnologia === 'FTTH'){
                  markerEdificios = L.marker(latlonEdificios, { icon: iconEdificiosAzul })
                  
                  .bindPopup(htmlPopup)
                  .openPopup();
                }else if(buildingData.tecnologia === 'FTTH/HFC'){
                    markerEdificios = L.marker(latlonEdificios, { icon: iconEdificiosVerde })
                  
                  .bindPopup(htmlPopup)
                  .openPopup();
                }else{
                  markerEdificios = L.marker(latlonEdificios, { icon: iconEdificiosAzul })
                  
                  .bindPopup(htmlPopup)
                  .openPopup();
                }

              
                
                  markerLayerBuildgindGroup.addLayer(markerEdificios);
              }

              this.map.addLayer(markerLayerBuildgindGroup);
            }
          });

          this.$store.commit("SET_LAYER_MARKER_BUILDINGS",markerLayerBuildgindGroup);


            // let dataEdificios = this.apiGetDataEficios(latitud, longitud);
            // console.log(dataEdificios)
           


           

           


            this.$store.commit("SET_LAYER_MARKER", marker);

            let place_id = results[item].place_id;
            this.$store.commit("SET_PLACE_ID", place_id);

            let address = result.standard_address;
            this.$store.commit("SET_ADDRESS", address);

            break;
          }
        }
      }
    },

    getGeofencingInalambricoIfiNacional() {
      let self = this;
      self.inalambrico_ifinacional = {};
      self.inalambrico_ifinacional5g = {};

      //let codeLayerArea = "xfgimiga2095";
      // let codeLayerArea = "jaseccqi2471";
      // let codeLayerArea = "wjupxdjq2724";
      let codeLayerArea = "pvtykgfz2932";
      // let codeLayerArea = "wpndwrfw3084";
      // let codeLayerArea5g = "zdohkswv2176";
      // --let codeLayerArea5g = "fdnqqcjk3657";
      let codeLayerArea5g = "atmcbzfx4522";

      //let token = "ea101536-6465-4902-92bf-6ab1a1c38194";
      let token = this.access_token;

      let latitud = this.latitud_general;
      let longitud = this.longitud_general;

      console.log(latitud);
      console.log(longitud);

      axios
        .get(
          this.urlBuilderArea +
            "latlon=" +
            latitud +
            "," +
            longitud +
            "&layer_area_id=" +
            codeLayerArea +
            "&key=" +
            token
        )
        .then((response) => {
          let dataGeofencing = response.data;

          if (dataGeofencing.status == "OK") {
            self.inalambrico_ifinacional.tieneCobertura = true;

            self.inalambrico_ifinacional.sectorStatus =
              dataGeofencing.area_status;
            self.inalambrico_ifinacional.plano = dataGeofencing.area_name;
            self.inalambrico_ifinacional.lat = dataGeofencing.lat;
            self.inalambrico_ifinacional.long = dataGeofencing.long;
          } else {
            self.inalambrico_ifinacional.tieneCobertura = false;
            self.inalambrico_ifinacional.sectorStatus =
              dataGeofencing.area_status;
          }

          axios
            .get(
              this.urlBuilderArea +
                "latlon=" +
                latitud +
                "," +
                longitud +
                "&layer_area_id=" +
                codeLayerArea5g +
                "&key=" +
                token
            )
            .then((response) => {
              let dataGeofencing = response.data;

              if (dataGeofencing.status == "OK") {
                self.inalambrico_ifinacional5g.tieneCobertura = true;

                self.inalambrico_ifinacional5g.sectorStatus =
                  dataGeofencing.area_status;
                self.inalambrico_ifinacional5g.plano = dataGeofencing.area_name;
                self.inalambrico_ifinacional5g.lat = dataGeofencing.lat;
                self.inalambrico_ifinacional5g.long = dataGeofencing.long;
              } else {
                self.inalambrico_ifinacional5g.tieneCobertura = false;
                self.inalambrico_ifinacional5g.sectorStatus =
                  dataGeofencing.area_status;
              }

              self.dialog_ifi_nacional = true;
            });
        });
    },

    getGeofencingInalambricoLteNacional() {
      let self = this;
      self.inalambrico_ltenacional = {};
      //let codeLayerArea = "biuaqfxj2096";
      let codeLayerArea = "yjvfjuyv2211";
      let codeLayerAreaSinr = "tmufjzwl2177";

      //let token = "ea101536-6465-4902-92bf-6ab1a1c38194";
      let token = this.access_token;

      let latitud = this.latitud_general;
      let longitud = this.longitud_general;

      axios
        .get(
          this.urlBuilderArea +
            "latlon=" +
            latitud +
            "," +
            longitud +
            "&layer_area_id=" +
            codeLayerArea +
            "&key=" +
            token
        )
        .then((response) => {
          let dataGeofencing = response.data;

          if (dataGeofencing.status == "OK") {
            self.inalambrico_ltenacional.tieneCobertura = true;

            self.inalambrico_ltenacional.areaStatus =
              dataGeofencing.area_status;
            self.inalambrico_ltenacional.antena = dataGeofencing.antenna;
            self.inalambrico_ltenacional.areaName = dataGeofencing.area_name;
            self.inalambrico_ltenacional.lat = dataGeofencing.lat;
            self.inalambrico_ltenacional.long = dataGeofencing.long;
          } else {
            self.inalambrico_ltenacional.tieneCobertura = false;
            self.inalambrico_ltenacional.areaStatus =
              dataGeofencing.area_status;
          }

          axios
            .get(
              this.urlBuilderArea +
                "latlon=" +
                latitud +
                "," +
                longitud +
                "&layer_area_id=" +
                codeLayerAreaSinr +
                "&key=" +
                token
            )
            .then((response) => {
              let dataGeofencing = response.data;

              if (dataGeofencing.status == "OK") {
                self.inalambrico_lte_sinr_nacional.sinr = dataGeofencing.sinr;
              }

              self.dialog_lte_nacional = true;
            });
        });
    },

    getGeofencingEntregaClientes() {
      let self = this;
      self.entrega_clientes = {};

      // let codeLayerArea = "oehlpjmf2151";
      let codeLayerArea = "wpndwrfw3084";
      //let token = "ea101536-6465-4902-92bf-6ab1a1c38194";
      let token = this.access_token;

      let latitud = this.latitud_general;
      let longitud = this.longitud_general;

      axios
        .get(
          this.urlBuilderArea +
            "latlon=" +
            latitud +
            "," +
            longitud +
            "&layer_area_id=" +
            codeLayerArea +
            "&key=" +
            token
        )
        .then((response) => {
          let dataGeofencing = response.data;

          if (dataGeofencing.status == "OK") {
            self.entrega_clientes.tieneCobertura = true;

            self.entrega_clientes.areaStatus = dataGeofencing.area_status;
            self.entrega_clientes.areaName = dataGeofencing.area_name;
            self.entrega_clientes.areaCondicion = dataGeofencing.condition;

            switch (dataGeofencing.colour) {
              case "AZUL":
                self.entrega_clientes.color = "#2727ff";
                break;
              case "VERDE":
                self.entrega_clientes.color = "#009d00";
                break;
              case "MORADO":
                self.entrega_clientes.color = "#663399";
                break;
              case "AMARILLO":
                self.entrega_clientes.color = "#b0b000";
                break;
              case "MARRON":
                self.entrega_clientes.color = "#a5492a";
                break;
              case "ROJO":
                self.entrega_clientes.color = "#ff1414";
                break;
              default:
                self.entrega_clientes.color = "#2727ff";
            }

            //self.entrega_clientes.color = dataGeofencing.colour;
            self.entrega_clientes.lat = dataGeofencing.lat;
            self.entrega_clientes.long = dataGeofencing.long;
            self.entrega_clientes.district = dataGeofencing.district;
          } else {
            self.entrega_clientes.tieneCobertura = false;
            self.entrega_clientes.areaStatus = dataGeofencing.area_status;
          }

          self.dialog_entrega_clientes = true;
        });
    },

    getGeofencingCoberturaHorizontal() {
      let self = this;
      self.cobertura_horizontal = {};
      //let codeLayerArea = "weicboeu2112";
      //let codeLayerArea = "iittroli2537";
      // let codeLayerArea = "qdjbmjks2663";
      // let codeLayerArea = "eloggbda2669";
      // let codeLayerArea = "ouluvakv3294";
      //let codeLayerArea = "viwrarrl3409";
      //let codeLayerArea = "oipoiebz3496";
      // let codeLayerArea = "veghjtvx3515";
      // let codeLayerArea = "emmayeyj3616";
      // let codeLayerArea = "fdnqqcjk3657";
      let codeLayerArea = "atmcbzfx4522";
      //let token = "ea101536-6465-4902-92bf-6ab1a1c38194";
      let token = this.access_token;

      let latitud = this.latitud_general;
      let longitud = this.longitud_general;

      axios
        .get(
          this.urlBuilderArea +
            "latlon=" +
            latitud +
            "," +
            longitud +
            "&layer_area_id=" +
            codeLayerArea +
            "&key=" +
            token
        )
        .then((response) => {
          let dataGeofencing = response.data;

          if (dataGeofencing.status == "OK") {
            self.cobertura_horizontal.tieneCobertura = true;

            self.cobertura_horizontal.areaStatus = dataGeofencing.area_status;
            self.cobertura_horizontal.areaName = dataGeofencing.area_name;
            self.cobertura_horizontal.tecnology = dataGeofencing.tecnology;
            self.cobertura_horizontal.district = dataGeofencing.district;
            self.cobertura_horizontal.department = dataGeofencing.department;
            self.cobertura_horizontal.region = dataGeofencing.region;
            self.cobertura_horizontal.services = dataGeofencing.services;
            self.cobertura_horizontal.capacity = dataGeofencing.capacity;
            self.cobertura_horizontal.corporate_status =
              dataGeofencing.corporate_status;
            self.cobertura_horizontal.corporate_service =
              dataGeofencing.corporate_service;
            self.cobertura_horizontal.lat = dataGeofencing.lat;
            self.cobertura_horizontal.long = dataGeofencing.long;

            // nuevos valores
            self.cobertura_horizontal.condition_value = dataGeofencing.condition_value;
            self.cobertura_horizontal.tipo_olt = dataGeofencing.tipo_olt;
            self.cobertura_horizontal.update_value = dataGeofencing.update_value;
            self.cobertura_horizontal.color = dataGeofencing.color;
          } else {
            self.cobertura_horizontal.tieneCobertura = false;
            self.cobertura_horizontal.areaStatus = dataGeofencing.area_status;
          }

          self.dialog_cobertura_horizontal = true;
        });
    },

    evaluatePrecision: function (nivel_precision_geocoder, nivel_detail) {
      console.log("PRECISION");
      console.log(nivel_precision_geocoder);
      console.log(nivel_detail);

      switch (nivel_precision_geocoder) {
        case "DOOR":
        case "INTERPOLATED":
          this.classForPrecision = "precision-alta";
          this.nivel_search = "Precisión Alta";
          break;
        case "CENTER":
          if (
            nivel_detail.includes("route") ||
            nivel_detail.includes("sublocality")
          ) {
            this.classForPrecision = "precision-media";
            this.nivel_search = "Precisión Media";
          }
          this.classForPrecision = "precision-baja";
          this.nivel_search = "Precisión Baja";
          break;
        default:
          this.classForPrecision = "precision-baja";
          this.nivel_search = "Precisión Baja";
      }
    },
  },
};
</script>
<style>
.box-card-claro {
  margin-top: 20px;
}

.box-card-claro .el-card__header {
  text-align: center;
  color: white;
  padding: 8px 20px;
}

.box-card-claro .el-card__body {
  position: relative;
  padding: 0px !important;
}

.box-card-claro .el-card__body .text {
  font-weight: bold;
  padding: 20px;
}

.precision-alta {
  padding: 5px 5px 5px 0px;
  color: #009700;
  font-size: 13px;
  text-align: center;
  border-bottom: #009700 1px solid;
}
.precision-media {
  padding: 5px 5px 5px 0px;
  color: #e69500;
  font-size: 13px;
  text-align: center;
  border-bottom: #e69500 1px solid;
}
.precision-baja {
  padding: 5px 5px 5px 0px;
  color: #0080ff;
  font-size: 13px;
  text-align: center;
  border-bottom: #0080ff 1px solid;
}

.rowComponentOfDirection {
  margin-top: 12px;
}

.rowNumberDirection {
  margin-top: 12px;
}

.containerSearchDirection {
  margin: 10px 10px;
}
.divIconDeleteInputNumberDirection {
  padding: 8px 6px;
}

.containerSearchDirection h5 {
  text-align: center;
}

.inputNumberDirection {
  width: 100% !important;
}

.inputNumberDirection input[type="text"] {
  text-align: left !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.lblNumeroVia {
  font-size: 14px;
}

.inputManzana {
  width: 100% !important;
  font-size: 14px;
}

.rowbtnSearchDirection {
  /*margin: 15px 0px;*/
}

.btnSearchDirection {
  width: 100%;
  border-radius: 2px !important;
}

.inputNumberDirection {
  width: 100%;
  color: #5c5c5c;
  font-size: 14px;
}

.inputNumberDirection.vs-input-number {
  background: white !important;
}

.inputNumberDirection .vs-input-number--input {
  min-width: 100px !important;
  background: white !important;
}

.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .glyphicon {
  position: absolute;
  padding: 6px;
}

/* align icon */
.left-addon .glyphicon {
  left: 0px;
}
.right-addon .glyphicon {
  right: 0px;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
.right-addon input {
  padding-right: 30px;
}

.iconInput {
  z-index: 2;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.delivery_code .el-input__inner {
  width: 100%;
  height: 25px;
  font-weight: bold;
  color: #ff4240;
  font-size: 12px;
  padding: 0 3px;
}

.notaDelivery {
  font-size: 12px;
  color: #269b26;
  font-style: italic;
}

.value-delivery {
  font-weight: 400;
}

.col-geofencing {
  margin-bottom: 5px;
}

.labelClaroGeofencing {
  font-size: 16px;
}

.valueClaroGeofencing {
  font-weight: bold;
  color: #b30000;
  font-size: 14px;
}

.el-dialog__header {
  background-color: #1e1e1e !important;
}

.el-dialog__title {
  color: white !important;
}

.col-button-geofencing {
  margin-bottom: 5px;
}

.col-coordinates-geofencing {
  text-align: center;
  margin-bottom: 5px;
  font-size: 12px;
  color: #5c5c5c;
}

.button-geofencing {
  width: 100%;
  padding: 8px;
}

.select-css {
  display: block;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%; /* useful when width is set to anything other than 100% */
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  /* note: bg image below uses 2 urls. The first is an svg data uri for the arrow icon, and the second is the gradient. 
    for the icon, if you want to change the color, be sure to use `%23` instead of `#`, since it's a url. You can also swap in a different svg icon or an external image reference
    
  */
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
  background-position: right 0.7em top 50%, 0 0;
  /* icon size, then gradient */
  background-size: 0.65em auto, 100%;
}
/* Hide arrow icon in IE browsers */
.select-css::-ms-expand {
  display: none;
}
/* Hover style */
.select-css:hover {
  border-color: #888;
}
/* Focus style */
.select-css:focus {
  border-color: #aaa;
  /* It'd be nice to use -webkit-focus-ring-color here but it doesn't work on box-shadow */
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}

/* Set options to normal weight */
.select-css option {
  font-weight: normal;
}

/* Support for rtl text, explicit support for Arabic and Hebrew */
*[dir="rtl"] .select-css,
:root:lang(ar) .select-css,
:root:lang(iw) .select-css {
  background-position: left 0.7em top 50%, 0 0;
  padding: 0.6em 0.8em 0.5em 1.4em;
}

/* Disabled styles */
.select-css:disabled,
.select-css[aria-disabled="true"] {
  color: graytext;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22graytext%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
}

.select-css:disabled:hover,
.select-css[aria-disabled="true"] {
  border-color: #aaa;
}
</style>
